import API from '../request/rebateManagement';

export const getRebateLoginUser = () => {
  return API.get('/user/getLoginUser');
};
// export const userLogin = (ticket) => API.get('user/user', { params: { ticket } });
export const userLogin = (params) => {
  return API.get('user/user', { params });
};
